import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MessageDialogGateUsersQueryVariables = Types.Exact<{
  input: Types.UserSelectionInput;
}>;


export type MessageDialogGateUsersQuery = { __typename?: 'Query', GetUsersForUserSelection: Array<{ __typename?: 'Employee', id: number }> };


export const MessageDialogGateUsersDocument = gql`
    query MessageDialogGateUsers($input: UserSelectionInput!) {
  GetUsersForUserSelection(input: $input) {
    id
  }
}
    `;

/**
 * __useMessageDialogGateUsersQuery__
 *
 * To run a query within a React component, call `useMessageDialogGateUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageDialogGateUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageDialogGateUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageDialogGateUsersQuery(baseOptions: Apollo.QueryHookOptions<MessageDialogGateUsersQuery, MessageDialogGateUsersQueryVariables> & ({ variables: MessageDialogGateUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageDialogGateUsersQuery, MessageDialogGateUsersQueryVariables>(MessageDialogGateUsersDocument, options);
      }
export function useMessageDialogGateUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageDialogGateUsersQuery, MessageDialogGateUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageDialogGateUsersQuery, MessageDialogGateUsersQueryVariables>(MessageDialogGateUsersDocument, options);
        }
export type MessageDialogGateUsersQueryHookResult = ReturnType<typeof useMessageDialogGateUsersQuery>;
export type MessageDialogGateUsersLazyQueryHookResult = ReturnType<typeof useMessageDialogGateUsersLazyQuery>;
export type MessageDialogGateUsersQueryResult = Apollo.QueryResult<MessageDialogGateUsersQuery, MessageDialogGateUsersQueryVariables>;